import React, { Component } from 'react';
import { connect } from 'react-redux';
import PublishedStatus from './PublishedStatus';
import PreviewProfile from './PreviewProfile';
import SwitchGuestMode from './SwitchGuestMode';
import PreferencesSet from './PreferencesSet';
import ProfileVideo from './ProfileVideo';
import { getProfileComplete } from '../../../actions';
import VideoModal from "../../../../../../dashboardNew/components/modals/VideoModal";

class PublishAndPreview extends Component {
	state = {
		isOpen: false,
		isVideoOpen: false,
		isModalOpen : false,
	};

	componentWillReceiveProps(nextProps) {
		this.props.visibility.visible !== nextProps.visibility.visible
			? this.props.getProfileComplete(this.props.name.personId)
			: null;
	}

	openModal = () => {
		this.setState({
			isModalOpen: true
		})
	};

	closeModal = () => {
		this.setState({
			isModalOpen: false
		})
	};

	render() {
		const { ui, forms } = this.props,
			{ guestMode, hideToggle } = ui;

		if (guestMode)
			return <SwitchGuestMode hideToggle={hideToggle} guestMode={guestMode} />;

		return (
			<section id="visibility" className="user-visibility">
				<div className="container has-padding-0">
					<div className="row">
						<div className="col-12 visibility-container">
							<VideoModal
								closeModal={this.closeModal}
								modalState={this.state.isModalOpen}
								videoUrl="https://fast.wistia.net/embed/iframe/r2uxy26eh5?videoFoam=true"
							/>
							<div className="profile-visibility-box">
								<h3 className="h3">Profile checklist &amp; visibility</h3>
								<ProfileVideo
									handleProfileVideoOpen={this.openModal}
								/>
								{!forms.editing && (
									<div>
										<PreviewProfile
											hideToggle={hideToggle}
											guestMode={guestMode}
										/>
										<PublishedStatus {...this.props} />
									</div>
								)}
								<PreferencesSet guestMode={guestMode} ui={ui} />
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}

const mapDispatchToProps = (dispatch, props) => ({
	getProfileComplete: personId => dispatch(getProfileComplete(personId)),
});

export default connect(
	null,
	mapDispatchToProps
)(PublishAndPreview);



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/visibility/PublishAndPreview.js